import PageSelector from './PageSelector'
import { Box } from '@material-ui/core'
import ZoomControls from './ZoomControls'

type PDFSelectionActionsProps = {
  numPages: number
  selectedPageNumber: number
  setSelectedPageNumber: (page: number) => void
  zoom: number
  setZoom: (zoom: number) => void
}

export default function PDFSelectionActions({
  numPages,
  selectedPageNumber,
  setSelectedPageNumber,
  zoom,
  setZoom,
}: PDFSelectionActionsProps): JSX.Element {
  return (
    <Box display='flex'>
      <ZoomControls zoom={zoom} setZoom={setZoom} />
      <PageSelector
        pageCount={numPages}
        pageNumber={selectedPageNumber}
        updateSelectedPageNumber={setSelectedPageNumber}
      />
    </Box>
  )
}
